import { Dialog } from '@headlessui/react';
import { Bars3Icon } from '@heroicons/react/24/solid';
import { XMarkIcon } from '@heroicons/react/24/solid';
import { useLocation } from '@reach/router';
import { useStaticQuery, graphql } from 'gatsby';
import React from 'react';
import Aside from '../aside';

interface Props {
  className?: string;
}

const MobileNavigation: React.FC<Props> = ({ className }) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = React.useState(false);
  const data = useStaticQuery<Queries.Query>(
    graphql`
      query NavigationData {
        allMarkdownRemark {
          edges {
            node {
              frontmatter {
                category
              }
              fields {
                slug
              }
            }
          }
        }
        allAsideJson {
          edges {
            node {
              category
              sections {
                links {
                  href
                  title
                }
                title
              }
            }
          }
        }
      }
    `,
  );

  const allPagesCategoryList = data.allMarkdownRemark.edges.map((x: any) => ({
    category: x.node.frontmatter.category,
    path: `/docs/${String(
      x.node.fields?.slug.replace(/\/$/, '').split('/').pop(),
    )}`,
  }));
  allPagesCategoryList.push(
    { category: 'service', path: '/docs/service' },
    { category: 'guide', path: '/docs/guide' },
    { category: 'price', path: '/docs/price' },
  );

  const currentPageCategory = allPagesCategoryList.find(
    (x: any) => x.path === location.pathname.replace(/\/$/, ''),
  )?.category;

  const aside = data.allAsideJson.edges.find(
    (edge: Queries.AsideJsonEdge) => edge.node.category === currentPageCategory,
  );

  const closeMobileNavigation = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button
        type='button'
        onClick={() => setIsOpen(true)}
        aria-label='Open navigation'
      >
        <Bars3Icon className={`h-8 w-8 text-lsGray-700 ${className}`} />
      </button>
      <Dialog
        open={isOpen}
        onClose={setIsOpen}
        className='fixed inset-0 z-50 flex items-start overflow-y-auto bg-lsGray-900 bg-opacity-40 pr-10 xl:hidden'
        aria-label='Navigation'
      >
        <Dialog.Panel className='min-h-full w-full max-w-xs bg-lsGray-700'>
          <div className='flex flex-row-reverse'>
            <button
              type='button'
              onClick={() => setIsOpen(false)}
              aria-label='Close navigation'
            >
              <XMarkIcon className='mx-4 my-3 h-8 w-8 text-white' />
            </button>
          </div>
          {aside && <Aside data={aside} onLinkClick={closeMobileNavigation} />}
        </Dialog.Panel>
      </Dialog>
    </>
  );
};

MobileNavigation.displayName = 'MobileNavigation';

export default MobileNavigation;
